<template>
  <div class="main" v-if="loading == false">
    <!--<div class="fakePopUp" id="fakePop">
      <p>
        Si vous voulez passer en pleine écran dès maintenant, toucher ou cliquer
        sur l'écran 2 fois rapidement
      </p>
    </div>-->
    <div class="connexion-section">
      <div class="image_connexion imgCoco">
        <img
          src="../assets/logo/logo-PREVENTMS2.png"
          alt="logo PreventTms"
          class="img_co"
        />
      </div>
      <form action="" method="post" class="loggin_form formCoco">
        <input
          type="text"
          v-model="user.mail"
          placeholder="Email"
          class="id"
          autocomplete="username"
        />
        <!--<div class="passComplet">-->
        <input
          type="password"
          v-model="user.password"
          placeholder="Mots de passe"
          class="mdp"
          id="currentPass"
          autocomplete="current-password"
        />
        <span
          toggle="#currentPass"
          :class="this.toggleClass"
          @click.prevent="changeToggle()"
          id="togglele"
        ></span>
        <!--</div>-->
        <div class="log_div">
          <div class="reme">
            <input
              type="checkbox"
              name="remember_me"
              id="remember_me"
              v-model="remember_me"
              checked="checked"
            />
            <label for="remember_me">Restez Connecté</label>
          </div>
          <router-link
            to="/changement_mots_de_passe"
            title="Mot de passe oublié"
            class="mdp_fgot"
            >Mot de passe oublié</router-link
          >
        </div>
        <button
          type="submit"
          class="connexion-submit subCo"
          @click.prevent="postInfo()"
        >
          Connexion
        </button>
      </form>
    </div>
    <!--<button id="show-modal" @click="showModal = true">CGU</button>-->
    <!-- use the modal component, pass in the prop -->
    <CGU
      v-if="showModal"
      :close="showModal"
      @close="showModal = false"
      @passOk="co()"
      @passPasOk="deco()"
    >
      <!--
      you can use custom content here to overwrite
      default content
    
        <h3 slot="header">custom header</h3>-->
    </CGU>
  </div>
  <div class="main  mainLoader" v-else>
    <circleLoader :when="loading"></circleLoader>
  </div>
</template>

<script>
import { User } from "../controller/user.js";
import { hostUrl } from "../_helpers/global_var";
import circleLoader from "@/components/Circle-loader";
import * as controle from "../controller/correctionEcran.js";
import CGU from "@/components/CGU";

const axios = require("axios").default;
const dateLimit = new Date("2020-05-01");

export default {
  name: "Connecion",
  data() {
    return {
      user: new User(),
      remember_me: true,
      loading: false,
      testsInitialises: false,
      toggleClass: "fa fa-fw fa-eye field-icon toggle-password",
      showModal: false,
      passDroit: false
    };
  },
  components: {
    circleLoader,
    CGU
  },
  created() {
    /*setTimeout(function displayFake() {
      let koko = document.getElementById("fakePop");
      koko.classList.remove();
      koko.classList.add("fakeOff");
    }, 3000);*/
  },
  methods: {
    async postInfo() {
      this.loading = true;
      //console.log('identifiant = ' + this.user.mail, 'password = '+this.user.password, 'remember_me = ' + this.remember_me);
      let json = JSON.stringify(this.user);
      localStorage.user = json;
      console.log(localStorage.user, this.user.jsonSend());

      await axios

        .post(hostUrl + "/salarie", this.user.jsonSend())
        .then(response => this.userOk(response, this.user.password))
        .catch(error => this.errorOK(error));

      console.log(localStorage.user);
    },
    changeToggle() {
      var toggle = document.getElementById("togglele");
      if (this.toggleClass == "fa fa-fw fa-eye field-icon toggle-password") {
        this.toggleClass = "fa fa-eye-slash field-icon toggle-password";
      } else {
        this.toggleClass = "fa fa-fw fa-eye field-icon toggle-password";
      }

      var input = document.getElementById("currentPass");
      if (input.type == "password") {
        input.type = "text";
      } else {
        input.type = "password";
      }
    },
    userOk(response, pass) {
      let koko = new User(response.data);
      console.log(this.testsInitialises);
      koko.password = pass;
      localStorage.user = JSON.stringify(koko);
      let dateCgu = koko.dateCGU;
      console.log(dateCgu);
      if (koko.password == koko.nom_entreprise) {
        return this.$router.push({ name: "Changement_Mdp" });
      } else if (
        (dateCgu == null || dateCgu == "null") &&
        this.passDroit == false
      ) {
        console.log("ko");
        this.loading = false;
        return this.showModal = true;
      } else if (new Date(dateCgu) < dateLimit) {
        this.loading = false;
        return this.showModal = true;
      } else if (koko.poids == null || koko.taille == null) {
        return this.$router.push({ name: "Questionnaire" });
      } else if (this.testsInitialises == false) {
        this.verifyTest(koko.salarie_id);
      } else if (koko.name == "demo" || koko.prenom == "demo") {
        this.loading = false;
        alert(
          "Attention cet utilisateur n\a pas été créé, nous vous invitons à contacter votre service dédié"
        );
      } else if (
        koko.salarie_id == null ||
        koko.salarie_id == "undefined" ||
        koko.salarie_id == ""
      ) {
        this.loading = false;
        alert(koko);
      }

      if (koko.name == "demo" || koko.prenom == "demo") {
        this.loading = false;
        alert(
          "Attention cet utilisateur n\a pas été créé, nous vous invitons à contacter votre service dédié"
        );
      } else {
        return this.$router.push({ name: "Accueil" });
      }
    },
    errorOK(error) {
      this.loading = false;
      alert("Le mots de passe ou l'identifiant est éronné.");
      console.log(error);
    },
    async appelApi(id) {
      await axios
        .get(hostUrl + "/salarie/infoResultat/" + id)
        .then(
          response => (localStorage.resultats = JSON.stringify(response.data))
        )
        .then(function() {
          try {
            let tests = JSON.parse(localStorage.resultats);
            if (tests.lenght !== 0 && tests !== null) {
              let date = new Date(
                Number(tests[0].date.substring(6, 10)) + 1,
                Number(tests[0].date.substring(3, 5))
              );
              let dateNow = new Date();
              if (date < dateNow) {
                localStorage.refaireDoudou = true;
                localStorage.refaireTest = true;
                return this.$router.push({ name: "Test" });
              } else {
                this.testsInitialises = true;
              }
            } else {
              this.testsInitialises = false;
            }
          } catch (error) {}
        })
        .catch(error => console.log(error));
    },
    async verifyTest(id) {
      if (
        typeof localStorage.resultats !== undefined &&
        localStorage.length > 2 &&
        localStorage.resultats !== "[]"
      ) {
        this.testsInitialises = true;
      } else {
        this.appelApi(id).then();
      }
    },
    deco() {
      console.log("koko");
    },
    co() {
      passDroit = true;
      this.userOk(user, user.pass);
    }
  },

  mounted() {
    /*controle.dblclick();
    controle.stopRecizeMyScreen();*/
  },
  /*watch(){
    /*
window.addEventListener('native.hidekeyboard', keyboardHideHandler);
window.addEventListener('native.showkeyboard', keyboardShowHandler);

function keyboardShowHandler(e){
 isKeyboardOpen = true; //always know status
}

function keyboardHideHandler(e){
 isKeyboardOpen = false;
}

/*var element = document.getElementById("element"); // the input field
var focused = false;

var virtualKeyboardHeight = function () {
    var sx = document.body.scrollLeft, sy = document.body.scrollTop;
    var naturalHeight = window.innerHeight;
    window.scrollTo(sx, document.body.scrollHeight);
    var keyboardHeight = naturalHeight - window.innerHeight;
    window.scrollTo(sx, sy);
    return keyboardHeight;
};

element.onfocus = function () {
    focused = true;
    setTimeout(function() {
        element.value = "keyboardHeight = " + virtualKeyboardHeight()
    }, 1); // to allow for orientation scrolling
};

window.onresize = function () {
    if (focused) {
        element.value = "keyboardHeight = " + virtualKeyboardHeight();
    }
};

element.onblur = function () {
    focused = false;
};
  }*/

  beforeRouteLeave: (to, from, next) => {
    localStorage.quitAnalyse = true;
    if (this.testsInitialises == false) {
      console.log("here");
      next("Test");
    } else {
      next();
    }
  }
};
</script>
<style>
.fakePopUp {
  width: 80%;
  height: 70px;
  background-color: rgba(211, 211, 211, 0.7);
  border: none;
  margin-left: auto;
  margin-right: auto;
  position: absolute !important;
  top: 20px !important;
  visibility: visible;
  opacity: 1 !important;
  transform: translateY(0px) !important;
  transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}
.fakeOff {
  position: absolute !important;
  top: 20px !important;
  visibility: hidden;
  opacity: 0 !important;
  transform: translateY(-30px) !important;
  transition: visibility 2s, opacity 1.5s, transform 1.5s linear !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Connexion.vue